import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[collapseTemplate]'
})
export class CollapseTemplateDirective {

  private _name: string;

  @Input()
  set collapseTemplate(value: 'contentHead' | 'contentBody') {
    this._name = value;
  }

  get name(): string {
    return this._name;
  }

  constructor(public template: TemplateRef<any>) { }

  getType(): string {
    return this.name;
  }

}
